import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

const ProtectedRoute = ({ children }) => {
  const { user, isAdmin, isLoading } = useAppContext();
  const [canAccess, setCanAccess] = useState(null);

  useEffect(() => {
    console.log('🔐 ProtectedRoute Check:', { 
      userEmail: user?.email, 
      isAdmin, 
      isLoading,
      user: !!user
    });

    if (isLoading) {
      console.log('⏳ Still loading auth state...');
      setCanAccess(null);
      return;
    }

    if (!user) {
      console.log('❌ No user logged in - redirecting to login');
      setCanAccess(false);
      return;
    }

    if (!isAdmin) {
      console.log('❌ User is not admin:', user.email);
      console.log('⚠️ This user does not have admin permissions');
      setCanAccess(false);
      return;
    }

    console.log('✅ Access GRANTED for admin user:', user.email);
    setCanAccess(true);
  }, [user, isAdmin, isLoading]);

  // Show loading state
  if (isLoading || canAccess === null) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-white text-lg">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated or not admin
  if (!canAccess) {
    console.log('🚫 Access DENIED - Redirecting to login');
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;